var map = {
	"./blackGold/footer/Icon-more.png": 15763,
	"./brownGold/footer/Icon-more.png": 54126,
	"./darkBlue/footer/Icon-more.png": 69324,
	"./greenYellow/footer/Icon-more.png": 83161,
	"./redGold/footer/Icon-more.png": 24279,
	"./skyBlue/footer/Icon-more.png": 62376,
	"./whiteGold/footer/Icon-more.png": 29982,
	"./yellowWhite/footer/Icon-more.png": 4516
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68992;